import * as yup from 'yup'

export const dropdownValidation = (value: string) => {
  return yup.string().required(`Select ${value}`)
}
